import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-data-filter-group',
  templateUrl: './data-filter-group.component.html',
  styleUrls: ['./data-filter-group.component.scss']
})
export class DataFilterGroupComponent implements OnInit {
  @Input() labelKey: string = null;
  @Input() spaceBetween = false;
  @Input() spaceAuto = false;
  @Input() marginBottom = false;
  @Input() useAvailableWidth = false;
  @Input() flexDirection: 'row' | 'column' = 'row';
  @Input() fieldset = false;
  @Input() fieldsetLegendKey: string = null;
  @Input() sectionLegendKey: string = null;
  @Input() helperKey: string = null;

  public ngOnInit(): void {}
}
